import { mxn } from "@/lib/format";
import { GRADO_TONE } from "@/lib/riesgoTokens";
import { Seccion } from "@/components/solicitudes/comite/IntegranteExpediente";

const Dato = ({ l, v, testid }) => (
  <div><dt className="text-slate-500">{l}</dt><dd className="font-medium text-slate-800" data-testid={testid}>{v}</dd></div>
);

export function PerfilTransaccional({ f }) {
  const p = f.perfil || {};
  const m = (v) => (v != null && v !== "" ? mxn(v) : "No capturado");
  return (
    <Seccion titulo="Perfil transaccional" testid={`comite-ficha-perfil-${f.cliente_id}`}>
      <dl className="grid grid-cols-1 gap-x-3 gap-y-1 text-[12px] sm:grid-cols-2">
        <Dato l="Ingreso mensual declarado" v={p.ingreso_mensual_declarado ? mxn(p.ingreso_mensual_declarado) : "No capturado"} testid={`comite-ficha-ingreso-${f.cliente_id}`} />
        <Dato l="Origen de los recursos" v={p.origen_recursos || "No capturado"} />
        <Dato l="Monto mensual estimado" v={m(p.monto_max_mensual_estimado)} />
        <Dato l="Operaciones estimadas al mes" v={p.num_operaciones_estimadas ?? "No capturado"} />
        <Dato l="Promedio real mensual" v={m(p.monto_mensual_promedio)} />
        <Dato l="Desviación del perfil" v={p.hay_desviacion ? `Sí${p.desviacion_nivel ? ` · ${p.desviacion_nivel}` : ""}` : "No"} />
      </dl>
      {!p.registrado && <p className="mt-1 text-[11px] text-slate-500">Sin perfil transaccional registrado en Cumplimiento.</p>}
    </Seccion>
  );
}

export function EstatusPld({ f }) {
  const d = f.pld || {};
  const tono = GRADO_TONE[d.grado_riesgo] || "bg-slate-100 text-slate-600 border-slate-200";
  const coinc = d.coincidencia_confirmada ? ["Coincidencia confirmada en listas", "border-red-200 bg-red-100 text-red-700"]
    : d.coincidencia_pendiente ? ["Coincidencia pendiente de revisión", "border-amber-200 bg-amber-100 text-amber-800"]
      : ["Sin coincidencias pendientes ni confirmadas", "border-emerald-200 bg-emerald-100 text-emerald-700"];
  return (
    <Seccion titulo="Estatus PLD (resumen)" testid={`comite-ficha-pld-${f.cliente_id}`}>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${tono}`} data-testid={`comite-pld-grado-${f.cliente_id}`}>
          Grado de riesgo: {d.grado_riesgo || "Sin evaluar"}
        </span>
        <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${coinc[1]}`} data-testid={`comite-pld-coincidencia-${f.cliente_id}`}>
          {coinc[0]}
        </span>
      </div>
    </Seccion>
  );
}
